import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

/**
 * A component for visualising a loading state
 */
function Loading({ inline, text }) {
  const { t } = useTranslation();

  const loadingClasses = classNames('app-loading', {
    'app-loading--inline': inline
  });

  return (
    <div className={loadingClasses} role="alert" aria-busy="true">
      {text || <span className="visually-hidden">{t('styleguide:data_loading')}</span>}
    </div>
  );
}

Loading.propTypes = {
  /**
   * The flag to display as inline
   */
  inline: PropTypes.bool,
  /**
   * The text content
   */
  text: PropTypes.string
};

export default Loading;
